import { Hero } from "@/features/client/sections/Home/Hero";
import { Featured } from "@/features/client/sections/Home/Featured";
import { Testimonials } from "@/features/client/sections/Home/Testimonials";
import { Video } from "@/features/client/sections/Home/Video";

export default function Home() {
  return (
    <main className="min-h-screen">
      <Hero />
      <Featured />
      <Video />
      <Testimonials />
    </main>
  );
}
